<section class="team details-page-section">
    <p-toast key="toastMsg"></p-toast>
    <div class="container aos-init aos-animate" data-aos="">
        <div class="row">
            <div class="mobile-header-stickybackButton"><a onclick="history.back()"
                class="mobile-header"><i class="bx bx-chevron-left"
                    style="color: #fff; font-size: 1.6em;"></i> Back </a></div>
            <div class="col-md-12 academicslider academies-details-top">
                <div class="academies-details-page">
                    <div class="media">
                        <div class="media-left">
                            <div class="academies-image">
                                <img [src]="(imageprofile) ? imageprofile : '../../../../assets/images/academy_dummy.jpg'" alt="" class="w-100 lazy">
                            </div>
                        </div>
                        <div class="media-body">
                            <div class="academies-name">
                                <h4>{{academyname}}</h4>
                            </div>
                            <!-- <div class="rating-star">
                                <ul>
                                    <div class="founded-year">{{foundedyear}}
                                    </div>
                                    <li>
                                        <span>
                                            <i class='bx bxs-star'></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <i class='bx bxs-star'></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <i class='bx bxs-star'></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <i class='bx bxs-star'></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            <i class='bx bx-star'></i>
                                        </span>
                                    </li>
                                    <div class="count">4.0</div>
                                </ul>
                            </div> -->
                            <div class="academies-loction">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z">
                                    </path>
                                </svg>
                                <div class="location">
                                    {{location}}
                                </div>
                            </div>
                        </div>
                        <div class="contact-us-buttons">
                            <ul>
                                <li>
                                    <a href="tel:{{mobilenumber}}">
                                        <button class="Call">
                                            <span><i class='bx bx-phone-call'></i></span>{{mobilenumber}}</button>
                                    </a>
                                </li>
                                <li *ngIf="email">
                                    <a href="mailto:{{email}}" target="_blank"> <button class="email">
                                            <span><i class='bx bx-envelope'></i></span>{{email}}
                                        </button>
                                    </a>
                                </li>
                                <li *ngIf="website">
                                    <button class="">
                                        <a href="{{website}}" target="_blank"><i class='bx bx-globe'></i>{{website}}</a>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="col-md-12 mobile-p-none">
                    <div class="short-discription">
                        <div [innerText]="description"></div>
                    </div>
                </div>
                <hr *ngIf="description != ''">
            </div>
        </div>
    </div>
</section>
<section class="shedule-section"
    *ngIf="isMonday || isTuesday || isWednesday || isThursday || isFriday || isSaturday || isSunday || beginnerMorning!=undefined || beginnerEvening!=undefined || intermediateMorning!=undefined || intermediateEvening!=undefined || advanceMorning!=undefined || advanceEvening!=undefined">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2> <a> Schedule And Timing </a> </h2>
                </div>
            </div>
            <div class="shedule-tt">
                <div class="training-days">
                    <h4>TRAINING DAYS</h4>
                    <ul
                        *ngIf="isMonday || isTuesday || isWednesday || isThursday || isFriday || isSaturday || isSunday">
                        <li *ngIf="isMonday">
                            <button>
                                Monday
                            </button>
                        </li>
                        <li *ngIf="isTuesday">
                            <button>
                                Tuesday
                            </button>
                        </li>
                        <li *ngIf="isWednesday">
                            <button>
                                Wednesday
                            </button>
                        </li>
                        <li *ngIf="isThursday">
                            <button>
                                Thursday
                            </button>
                        </li>
                        <li *ngIf="isFriday">
                            <button>
                                Friday
                            </button>
                        </li>
                        <li *ngIf="isSaturday">
                            <button>
                                Saturday
                            </button>
                        </li>
                        <li *ngIf="isSunday">
                            <button>
                                Sunday
                            </button>
                        </li>
                    </ul>
                    <ul
                        *ngIf="!isMonday && !isTuesday && !isWednesday && !isThursday && !isFriday && !isSaturday && !isSunday">
                        <li>
                            All Day
                        </li>
                    </ul>
                </div>

                <div class="training-time">
                    <h4>TRAINING HOURS
                    </h4>

                    <p><strong>Monday – Sunday</strong> </p>
                    <ul>
                        <li
                            *ngIf="(beginnerMorning!=undefined && beginnerMorning!='')|| (beginnerEvening!=undefined && beginnerEvening!='')">
                            <h6>Beginner</h6>
                            <p *ngIf="(beginnerMorning!=undefined && beginnerMorning!='')"> Morning ::
                                {{beginnerMorning}}</p>
                            <p *ngIf="(beginnerEvening!=undefined && beginnerEvening!='')"> Evening ::
                                {{beginnerEvening}}</p>
                        </li>

                        <li
                            *ngIf="(intermediateMorning!=undefined && intermediateMorning!='')|| (intermediateEvening!=undefined && intermediateEvening!='')">
                            <h6>Intermediate</h6>
                            <p *ngIf="intermediateMorning!=undefined"> Morning :: {{intermediateMorning}}</p>
                            <p *ngIf="intermediateEvening!=undefined"> Evening :: {{intermediateEvening}}</p>
                        </li>
                        <li
                            *ngIf="(advanceMorning!=undefined && advanceMorning!='') || (advanceEvening!=undefined && advanceEvening!='')">
                            <h6>Advance</h6>
                            <p *ngIf="(advanceMorning!=undefined && advanceMorning!='')"> Morning :: {{advanceMorning}}
                            </p>
                            <p *ngIf="(advanceEvening!=undefined && advanceEvening!='')"> Evening :: {{advanceEvening}}
                            </p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="button-chart mx-auto" *ngIf="showPdf"> <a href="{{academyFeesDoc}}" target="_blank"
                    class="orange-transparent-button " download>
                    <button class="btn btn-primary">View
                        Fees Chart</button>
                </a>
            </div>
        </div>
    </div>
</section>
<section class="Highlights-section pt-0" *ngIf="highlightlist.length > 0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="col-md-12 programs-section">
                    <div class="col-md-12 programs-section-headings-main">
                        <div class="section-title text-center">
                            <h2> <a target="_blank">WOW Factor / Achievements</a> </h2>
                        </div>
                    </div>


                    <!--light Box --->
                    <p-galleria [(value)]="images" [(visible)]="displayBasic" [responsiveOptions]="responsiveOptions"
                        [containerStyle]="{ 'max-width': '850px' }" [numVisible]="7" [circular]="true"
                        [fullScreen]="true" [showItemNavigators]="false" [showThumbnails]="false">
                        <ng-template pTemplate="item" let-item>
                            <img [src]="showHighlightImg" style="width: 100%; display: block;" />
                        </ng-template>
                    </p-galleria>
                    <p:hotkey bind="esc" handler="dlg1.hide(); dlg2.hide();..." />
                    <!--light Box --->



                    <div *ngIf="highlightlist.length > 0" class="col-md-12 programs-section-headings-main slider">
                        <div class="swiper high-light-slider">
                            <div class="swiper-slide" *ngFor="let highlight of highlightlist">
                                <div class="heiglght-div card">
                                    <div class="image" (click)="openHightlightImage(highlight);">
                                        <img src="{{highlight.image}}" alt="" class="w-100"
                                            style="width: auto; object-fit: contain;">
                                    </div>
                                    <div class="discription-div">
                                        <div class="headigns">
                                            <h4>{{highlight.heading}}</h4>
                                        </div>
                                        <p class="subhead">{{highlight.descriptions}}</p>
                                    </div>


                                </div>


                            </div>
                        </div>
                    </div>
                    <div *ngIf=" highlightlist.length == 0">
                        <div class="not-found-section">
                            <div class="col-md-12 not-found-body">
                                <img src="assets/img/logo/not-found.gif" alt="">
                                <h4>No Data Available!</h4>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</section>

<section class=" top-player main" *ngIf="playerlist.length > 0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2> Top Players </h2>
                </div>
            </div>
            <div class="col-md-12" *ngIf="playerlist.length > 0">
                <div class="swiper players">
                    <swiper class="swiper-wrapper" fxFlex="auto" [config]="topplayer_config" [disabled]="disabled"
                        (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                        (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                        <div class="swiper-slide" *ngFor="let player of playerlist">
                            <img src="{{player.image}}" alt="" class="w-100">
                            <div class="main-div">
                                <h2>{{player.playerName}}</h2>
                                <div class="price-details ">
                                    <div class="price-per">
                                        <div class="text" showDelay="1000">
                                            {{player.descriptions}}


                                        </div>
                                        <!-- <div class="read-more" *ngIf="player.descriptions !=''"><button
                                                (click)="openDialog(player)">Read
                                                More</button></div> -->
                                        <!-- <button type="text" (mouseover)="openDialog('email_signature')" pButton
                                            icon="pi pi-external-link"
                                            style="width: auto; height: auto; padding: 2px 5px;"></button> -->


                                        <div class="social-links ">
                                            <a href="{{player.youtubeUrl}}" class="youtube"><i
                                                    class="bx bxl-youtube"></i></a>
                                            <a *ngIf="player.fbUrl!=null" href="{{player.fbUrl}}" class="facebook"
                                                target="_blank"><i class="bx bxl-facebook"></i></a>
                                            <a *ngIf="player.instagramUrl!=null" href="{{player.instagramUrl}}"
                                                class="instagram" target="_blank"><i class="bx bxl-instagram"></i></a>
                                            <a *ngIf="player.skypeUrl!=null" href="{{player.skypeUrl}}"
                                                class="google-plus"><i class="bx bxl-skype"></i></a>
                                            <a *ngIf="player.linkedinUrl!=null" href="{{player.linkedinUrl}}"
                                                target="_blank" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="hover-div">
                                <div class="div-header">
                                    <div class="player-img">
                                        <img src="{{player.image}}" alt="" class="w-100">
                                    </div>
                                    <div class="palyer-name">
                                        <h6>{{player.playerName}}</h6>
                                    </div>
                                </div>

                                <div class="div-body">
                                    {{player.descriptions}}

                                </div>
                                <div class="div-footer">
                                    <div class="social-links ">
                                        <a href="{{player.youtubeUrl}}" class="youtube"><i
                                                class="bx bxl-youtube"></i></a>
                                        <a href="{{player.fbUrl}}" class="facebook"><i class="bx bxl-facebook"></i></a>
                                        <a href="{{player.instagramUrl}}" class="instagram"><i
                                                class="bx bxl-instagram"></i></a>
                                        <a href="{{player.skypeUrl}}" class="google-plus"><i
                                                class="bx bxl-skype"></i></a>
                                        <a href="{{player.linkedinUrl}}" class="linkedin"><i
                                                class="bx bxl-linkedin"></i></a>
                                    </div>
                                </div>
                            </div> -->


                        </div>
                    </swiper>
                </div>
            </div>
            <div *ngIf="playerlist.length == 0">
                <div class="not-found-section">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4>No Data Available!</h4>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="top-player Courts-section" *ngIf="courtlist.length > 0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2> Courts </h2>
                </div>
            </div>
            <div *ngIf="courtlist.length > 0" class="col-md-12 ">
                <div class="swiper Courts">
                    <swiper class="swiper-wrapper" fxFlex="auto" [config]="court_config" [disabled]="disabled"
                        (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                        (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                        <div class="swiper-slide" *ngFor="let court of courtlist">
                            <img src="{{court.image}}" alt="" class="w-100" (click)="openCourtImage(court);">
                            <div class="main-div">
                                <h2>Surface: {{court.court}}</h2>
                            </div>
                        </div>
                    </swiper>
                </div>
            </div>
            <div *ngIf="courtlist.length == 0">
                <div class="not-found-section">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4>No Data Available!</h4>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="academic-service" *ngIf="totalcourt > 0  || totalplayers> 0 || totalcoach > 0">
    <div class="container-fluid text-center">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2>
                        <a> HIGHLIGHTS </a>
                    </h2>
                </div>
            </div>
            <div class="timee-list-div">
                <div class="col-sm-3 timer-div" *ngIf="totalcourt">
                    <h2 data-max="50"> <span>Courts</span> </h2>
                    <h1>{{totalcourt}}</h1>
                </div>
                <div class="col-sm-3 timer-div" *ngIf="totalplayers">
                    <h2 data-max="100"> <span>Top Players</span> </h2>
                    <h1>{{totalplayers}}</h1>
                </div>
                <div class="col-sm-3 timer-div" *ngIf="totalcoach">
                    <h2 data-max="30" id="test"> <span>Coaches</span> </h2>
                    <h1>{{totalcoach}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="academic-service branch-services" *ngIf="branchlist.length>0">
    <div class="container text-center">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2>
                        <a> Branches </a>
                    </h2>
                </div>
            </div>
            <div *ngIf="branchlist.length>0" class="swiper branch-list-div  branch-list-divslider main">
                <swiper class="swiper-wrapper" fxFlex="auto" [config]="branch_config" [disabled]="disabled"
                    (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div class="swiper-slide" *ngFor="let branch of branchlist">
                        <div class="col-sm-12 branch-list-div ">
                            <div class="media">
                                <div class="media-left">
                                    <img src="{{branch.image}}" alt="" class="w-100">
                                </div>
                                <div class="media-body">
                                    <div class="Name ">
                                        <h4>{{branch.name}}</h4>
                                    </div>
                                    <div class="contact-us-buttons">
                                        <ul>
                                            <li *ngIf="branch.address">
                                                <a href="#">
                                                    <button>
                                                        <div class="location list">
                                                            <span><i class="bi bi-geo-alt"></i></span>
                                                            {{branch.address}}
                                                        </div>
                                                    </button>
                                                </a>
                                            </li>
                                            <li *ngIf="branch.mobileNumber">
                                                <a href="tel:{{branch.mobileNumber}}">
                                                    <button class="Call">
                                                        <span><i class="bx bx-phone-call"></i></span>
                                                        {{branch.mobileNumber}}
                                                    </button>
                                                </a>
                                            </li>
                                            <li *ngIf="branch.email">
                                                <a href="mailto:{{branch.email}}" target="_blank"> <button
                                                        class="email">
                                                        <span><i class="bx bx-envelope"></i></span> <em>
                                                            {{branch.email}}</em>
                                                    </button>
                                                </a>
                                            </li>
                                            <li *ngIf="branch.webUrl">
                                                <a href="#" [ngStyle]="{pointerEvents: 'none'}"> <button class="email">
                                                        <span><i class="bx bx-globe"></i></span>
                                                        <em>{{branch.webUrl}}</em>
                                                    </button></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
            <div *ngIf="branchlist.length == 0">
                <div class="not-found-section">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4>No Data Available!</h4>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="slider-section" *ngIf="sliderImages.length>0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2>
                        <span>Academy Gallery </span>
                    </h2>
                </div>
            </div>
            <div *ngIf="sliderImages.length>0" class="upload__img-wrap">
                <swiper class="swiper-wrapper" fxFlex="auto" [config]="slider_config" [disabled]="disabled"
                    (indexChange)="onIndexChange($event)" (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                    <div *ngFor="let slider of sliderImages " class="swiper-slide">
                        <div class="blog_card">
                            <div class="edit-button-show-click">
                            </div>
                            <div class="image">
                                <img src="{{slider.slider_image_src}}" alt="">
                            </div>
                        </div>
                    </div>
                </swiper>
            </div>
            <div *ngIf="sliderImages.length==0">
                <div class="not-found-section">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4>No Data Available!</h4>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="coach-list-section" *ngIf="coachData.length>0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2>
                        <a> Coaches </a>
                    </h2>
                </div>
            </div>
            <div *ngIf="coachData.length>0" class="col-md-12">
                <div class="coach-list">
                    <div class="coatch" *ngFor="let coach of coachData">
                        <div class="image">
                            <img src="{{coach.image}}" alt="">

                        </div>
                        <div class="header-heading">
                            <h4> {{coach.coachName}}</h4>
                            <h6>{{coach.coachRole}}</h6>
                        </div>
                    </div>

                </div>
            </div>
            <div *ngIf="coachData.length==0">
                <div class="not-found-section">
                    <div class="col-md-12 not-found-body">
                        <img src="assets/img/logo/not-found.gif" alt="">
                        <h4>No Data Available!</h4>
                        <p></p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section class="review-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title text-center">
                    <h2><a> Reviews </a></h2>
                </div>
                <!---Review Section-->
                <div class="review-section-Bottom">
                    <div class="col-md-12">
                        <div class="row">
                            <!-- <div class="col-md-12">
                                <div class="pull-right">
                                    <select class="reviews-fillter" name="">
                                        <option value="">Top reviews</option>
                                        <option value="">Most recent</option>
                                    </select>
                                </div>
                            </div> -->
                            <div class="col-md-4 review-top-right-side">
                                <div class="row">
                                    <div class="col-md-12 headign-revies-section-k">
                                        <h3>Ratings and reviews </h3>
                                    </div>
                                    <div class="col-md-6 mg-auto rTig">
                                        <div class="col-md-12 review-main-p">
                                            <div class="review-div">
                                                <div class="Ratings-point col-md-12">
                                                    <h1>{{totalRating?.toFixed(1)}}</h1>
                                                </div>
                                                <div class="rateing-star col-md-12">
                                                    <p-rating [cancel]="false" [readonly]="true"
                                                        [(ngModel)]="totalRating" iconOnClass="pi pi-star-fill"
                                                        iconOffClass="pi pi-star"></p-rating>
                                                    <div class="review-counting col-md-12">
                                                        <h2>(Total {{totalRecords}} Reviews)</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 progress-rating P-ratr">
                                        <ul>
                                            <li>
                                                <div class="media">
                                                    <div class="media-left">
                                                        <span>5</span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="progress">
                                                            <p-progressBar
                                                                [value]="fiveStar?.toFixed(0)"></p-progressBar>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="media">
                                                    <div class="media-left">
                                                        <span>4</span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="progress">
                                                            <p-progressBar
                                                                [value]="fourStar?.toFixed(0)"></p-progressBar>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="media">
                                                    <div class="media-left">
                                                        <span>3</span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="progress">
                                                            <p-progressBar
                                                                [value]="threeStar?.toFixed(0)"></p-progressBar>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="media">
                                                    <div class="media-left">
                                                        <span>2</span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="progress">
                                                            <p-progressBar
                                                                [value]="twoStar?.toFixed(0)"></p-progressBar>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="media">
                                                    <div class="media-left">
                                                        <span>1</span>
                                                    </div>
                                                    <div class="media-body">
                                                        <div class="progress">

                                                            <p-progressBar
                                                                [value]="oneStar?.toFixed(0)"></p-progressBar>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div *ngIf="!isAcademy" class="col-md-12 rate-this-item">
                                        <h5>Rate this Academy </h5>
                                        <p>Share your opinion with other users </p>
                                        <ul class="blank-star">
                                            <ul>
                                                <li>
                                                    <span><i class="pi pi-star"></i></span>
                                                </li>
                                                <li>
                                                    <span><i class="pi pi-star"></i></span>
                                                </li>
                                                <li>
                                                    <span><i class="pi pi-star"></i></span>
                                                </li>
                                                <li>
                                                    <span><i class="pi pi-star"></i></span>
                                                </li>
                                                <li>
                                                    <span><i class="pi pi-star"></i></span>
                                                </li>
                                            </ul>
                                        </ul>
                                        <p class="reviw-button-text" [ngClass]="{'is-disabled': !isLogin}">
                                            <a class="write-button-review cusror-pointer" (click)="reviewModal()">Write
                                                review and rate</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!--rihgt-sidee section-->
                            <div class="col-md-8 main-li-review-details">
                                <h3>Most important opinions </h3>
                                <!--main review list -->
                                <ul class="review-list-ul">
                                    <!-- <li class="reviw-user-main">
                                        <div class="review-comment-show">
                                            <div class="media">
                                                <img class="align-self-center mr-3"
                                                    src="https://tpl.wiantech.in/assets/img/players/1646919224786.jpg"
                                                    alt="customer-profile">
                                                <div class="media-body">
                                                    <div class="customer-name">
                                                        <h4>Leander Peas</h4>
                                                    </div>
                                                    <div class="rateing-star-customer">
                                                        <p-rating [cancel]="false" [readonly]="true"
                                                            [(ngModel)]="rating" iconOnClass="pi pi-star-fill"
                                                            iconOffClass="pi pi-star"></p-rating>
                                                    </div>
                                                    <span class="reviewed-date">12-12-2023</span>
                                                </div>
                                            </div>

                                            <div class="customer-comment">
                                                <p>Hello everyone. I just want to tell you that so far it has been an
                                                    excellent experience for me. The best tennis academy. </p>
                                            </div>
                                        </div>
                                    </li> -->
                                    <li class="reviw-user-main" *ngFor="let review of reviewsList">
                                        <div class="review-comment-show">
                                            <div class="media">
                                                <img class="align-self-center mr-3" src="{{review.userProfilePic}}"
                                                    alt="customer-profile">
                                                <div class="media-body">
                                                    <div class="customer-name">
                                                        <h4>{{review.userName}}</h4>
                                                    </div>
                                                    <div class="rateing-star-customer">
                                                        <p-rating [cancel]="false" [readonly]="true"
                                                            [(ngModel)]="review.rating" iconOnClass="pi pi-star-fill"
                                                            iconOffClass="pi pi-star"></p-rating>
                                                    </div>
                                                    <span
                                                        class="reviewed-date">{{review.created_at|date:'dd-MM-YYYY'}}</span>
                                                </div>
                                            </div>
                                            <!--Customer-text-review-->
                                            <div class="customer-comment">
                                                <p> {{review.comments}} </p>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                                <!--main review list close -->
                                <button *ngIf="reviewsList?.length > 0" type="button" (click)="onClickLoadMore()"
                                    name="button" class="review-more-button">
                                    Load More Reviews
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!---Review Section close -->
            </div>
        </div>
    </div>
</section>

<p-dialog header="{{playername}}" [(visible)]="visible" modal="true" showEffect="fade" class="modal-popup"
    [style]="{width: '650px'}">
    <div style="line-height: 1.5">

        <div class="price-details ">
            <div class="price-per">
                <div class="text" showDelay="1000">
                    {{playerDescription}}


                </div>

                <!-- <button type="text" (mouseover)="openDialog('email_signature')" pButton
                    icon="pi pi-external-link"
                    style="width: auto; height: auto; padding: 2px 5px;"></button> -->


                <!-- <div class="location list">
                    <span>
                        <i class="bi bi-geo-alt"></i>
                    </span> Mumbai
                </div> -->

            </div>
        </div>


    </div>
    <!-- <p-footer>
        <div class="social-links ">
            <a href="{{player.youtubeUrl}}" class="youtube"><i class="bx bxl-youtube"></i></a>
            <a href="{{player.fbUrl}}" class="facebook"><i class="bx bxl-facebook"></i></a>
            <a href="{{player.instagramUrl}}" class="instagram"><i class="bx bxl-instagram"></i></a>
            <a href="{{player.skypeUrl}}" class="google-plus"><i class="bx bxl-skype"></i></a>
            <a href="{{player.linkedinUrl}}" class="linkedin"><i class="bx bxl-linkedin"></i></a>
        </div>
    </p-footer> -->
</p-dialog>


<p-dialog header="Please Provide Feedback " [(visible)]="reviewModalPopup"
    [breakpoints]="{'960px': '75vw', '768px': 'calc(100% - 30px)'}" [draggable]="false" [style]="{width: '500px'}"
    [modal]="true" id="review-modal">
    <div class="rating-div">
        <div class="icons-acadmemy">
            <img [src]="(imageprofile) ? imageprofile : '../../../../assets/images/academy_dummy.jpg'" alt="Image not available">
        </div>
        <div class="rating-body">
            <div class="rating-heading col-md-12 mt-3">
                <h4> {{academyname}} </h4>
                <p class="note-acadmey">
                    What are your thoughts on your tournament experience with <span class="acName">{{academyname}}?</span>
                </p>
            </div>
            <div class="rating-div-star col-md-12">
                <p-rating [(ngModel)]="rating" (onRate)="onSelectRating()" iconOnClass="pi pi-star-fill"
                    iconOffClass="pi pi-star"></p-rating>
            </div>
            <div *ngIf="showRatingError">
                <span class="text-danger">Please select rating.</span>
            </div>
        </div>
    </div>

    <form *ngIf="reviewForm" [formGroup]="reviewForm" (ngSubmit)="onReviewSubmit()">
        <div class="comment-form col-md-12">
            <h5>Please share your opinions on the competition. </h5>
            <textarea [rows]="5" pInputTextarea formControlName="comments" placeholder="Write a review" class="w-100"
                [ngClass]="{'is-invalid':  ((submitted && f.comments.errors) || (f.comments.errors && (f.comments.dirty || f.comments.touched)))}"></textarea>
            <div *ngIf=" ((submitted && f.comments.errors) || (f.comments.errors && (f.comments.dirty || f.comments.touched)))"
                class="invalid-feedback">
                <div *ngIf="f.comments.errors.required">
                    Reviews are required.
                </div>
            </div>
        </div>
        <div class="col-md-12 reviews-button-footer">
            <button pButton class="review-btn">
                Submit Review
            </button>
        </div>
    </form>

</p-dialog>